<template>
    <v-dialog
        v-model="showDialog"
        persistent
    >
        <v-form
            ref="form"
            v-model="form"
            @submit.prevent="submitForm"
        >
            <v-card>
                <div class="d-flex align-center">
                    <v-tabs
                        v-model="tab"
                        background-color="transparent"
                        color="teal darken-1"
                        style="flex: 1 1 0; min-width: 0;"
                    >
                        <v-tab
                            v-for="item in tabItems"
                            :key="item"
                            :disabled="data && data.ACCT_N == null || generateQualifiedListData == null || loadingGenerateQualifiedList"
                            style="width: 150px; padding-top: 18px;"
                        >
                            <div
                                v-if="!loadingGenerateQualifiedList && allCount > 0 && generateQualifiedListData && generateQualifiedListData.data"
                            >
                                <v-badge :color="item === 'qualified' ? 'success' : item === 'all' ? 'secondary' : 'error'">
                                    {{ item }}<template #badge>
                                        {{ item === 'qualified' ? qualifiedCount : item === 'all' ? allCount : disqualifiedCount }}
                                    </template>
                                </v-badge>
                            </div>
                            <div v-else>
                                {{ item }}
                            </div>
                        </v-tab>
                    </v-tabs>
                    <v-text-field
                        v-model="search.query"
                        class="member-search"
                        clearable
                        dense
                        hide-details
                        placeholder="Search ..."
                        color="teal darken-1"
                        :append-icon="mdiMagnify"
                        :disabled="itemsTbl.length < 1 || loadingGenerateQualifiedList"
                        @keydown.enter.prevent="search.value = search.query"
                        @click:append="search.value = search.query"
                        @click:clear="search.value = null"
                    />

                    <v-chip
                        small
                        color="teal darken-1"
                        class="white--text selected-count"
                        style="font-weight: 700; margin: 0 16px 0 8px; flex-shrink: 0;"
                    >
                        {{ selected.length }} selected
                    </v-chip>
                </div>
                <MemberQualificationTable
                    :key="tableKey"
                    v-model="selected"
                    :items="itemsTbl"
                    :loading="loadingGenerateQualifiedList"
                    :disabled="data && data.ACCT_N == null"
                    :search="search.value"
                    always-allow-selection
                    :selected-members="members"
                />
                <v-card-actions>
                    <v-spacer />
                    <v-btn
                        color="teal darken-1"
                        outlined
                        :disabled="displayLoading || loadingGenerateQualifiedList"
                        @click="showDialog=false"
                    >
                        close
                    </v-btn>
                    <v-btn
                        color="teal darken-1 white--text"
                        :loading="displayLoading"
                        :disabled="loadingGenerateQualifiedList"
                        type="submit"
                    >
                        submit
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-form>
    </v-dialog>
</template>

<script>
import { mask } from 'vue-the-mask'
import { mapActions, mapGetters } from 'vuex'
import { moment } from '../../../../../../utils/date-shim'
import {
    mdiGenderMale,
    mdiGenderFemale,
    mdiMagnify
} from '@mdi/js'
import MemberQualificationTable from '../../../MemberQualificationTable.vue'

export default {
    directives: { mask },
    components: { MemberQualificationTable },
    props: ['show', 'data', 'notif', 'loading', 'members'],
    data: ()=>({
        tableKey: 0,
        selected: [],
        tab: null,
        search: {
            value: null,
            query: null
        },
        tabItems: ['all', 'qualified', 'disqualified'],
        mdiGenderMale,
        mdiGenderFemale,
        mdiMagnify,
        doneInsertMember: false,
        formSubmitted: false,
        loadingGenerateQualifiedList: false,
        memberList: [],
        form: null,
        rules: [v=>!!v||'This field is required',v=>v&&v.length===6||'Member number must be a 6-digit number'],
        displayLoading: false
    }),
    computed: {
        ...mapGetters(['insertMemberToScopedBenefitData', 'generateQualifiedListData']),
        allCount() {
            if (this.generateQualifiedListData && this.generateQualifiedListData.data) {
                const qualified = this.generateQualifiedListData.data.qualified.length
                const disqualified = this.generateQualifiedListData.data.disqualified.length
                return qualified + disqualified
            }
            return 0
        },
        qualifiedCount() {
            if (this.generateQualifiedListData && this.generateQualifiedListData.data) {
                return this.generateQualifiedListData.data.qualified.length
            }
            return 0
        },
        disqualifiedCount() {
            if (this.generateQualifiedListData && this.generateQualifiedListData.data) {
                return this.generateQualifiedListData.data.disqualified.length
            }
            return 0
        },
        itemsTbl() {
            if (this.data && this.data.ACCT_N !== null && this.generateQualifiedListData && this.generateQualifiedListData.data) {
                if (this.tab === 0) {
                    const qualified = this.generateQualifiedListData.data.qualified
                    const disqualified = this.generateQualifiedListData.data.disqualified
                    return [...qualified, ...disqualified]
                } else if (this.tab === 1) {
                    return this.generateQualifiedListData.data.qualified
                } else {
                    return this.generateQualifiedListData.data.disqualified
                }
            } else {
                return []
            }
        },
        showDialog: {
            get() {
                return this.show
            },
            set() {
                this.$emit('closeDialog')
            }
        }
    },
    watch: {
        'search.query'(newVal) {
            if (newVal === '' || newVal === null) {
                this.search.value = null
            }
        },
        generateQualifiedListData(newVal) {
            this.loadingGenerateQualifiedList = false
            if (newVal) {
                if (newVal.status === 200) {
                    let qualified = []
                    let disqualified = []
                    const items = newVal.data
                    qualified = items.qualified.map(item => ({ ...item, QUALIFIED: true, nameAndMemberNumber: `${item.MEMB_N} ${item.LAST_M}` }))
                    disqualified = items.disqualified.map(item => ({ ...item, QUALIFIED: false, nameAndMemberNumber: `${item.MEMB_N} ${item.LAST_M}` }))
                    let newList = [...qualified, ...disqualified]
                    let alreadyAddedMembers = this.members
                    for (let i=0; i<alreadyAddedMembers.length; i++) {
                        const indexOfSelected = newList.findIndex(item => item.MEMB_N === alreadyAddedMembers[i].MEMB_N)
                        if (indexOfSelected >= 0) {
                            newList.splice(indexOfSelected, 1)
                        }
                    }
                    this.memberList = structuredClone(newList)
                }
            }
        },
        show(newVal) {
            if (newVal) {
                this.resetSearch()
                this.selected = []
                this.tab = 0
                this.tableKey++                    // remount the table with fresh state
                this.loadingGenerateQualifiedList = true
                this.generateQualifiedList({ ACCT_N: this.data.ACCT_N })
            }
            this.$nextTick(() => {
                this.resetForm()
            })
        },
        doneInsertMember(newVal) {
            if (newVal) {
                this.fetchMembersOfScopedBenefit(this.data)
                this.showDialog = false
                this.loading.fetch = true
            }
        },
        insertMemberToScopedBenefitData(newVal) {
            if (newVal) {
                if (newVal.status !== 200) {
                    this.notif.type = 'error'
                    this.notif.color = 'error'
                    this.notif.timeout = 5000
                    this.notif.msg = newVal.state
                    this.notif.show = true
                } else {
                    this.notif.type = 'success'
                    this.notif.color = 'success'
                    this.notif.timeout = 5000
                    this.notif.msg = `Member${this.memberList.length>1?'s':''} added successfully`
                    this.notif.show = true
                }
            }
        }
    },
    methods: {
        ...mapActions(['insertMemberToScopedBenefit', 'fetchMembersOfScopedBenefit', 'generateQualifiedList']),
        resetSearch() {
            this.search.query = null
            this.search.value = null
        },
        formatDateToPst(date) {
            if (date) {
                return moment(date).utcOffset('+0800').format('MMMM DD, YYYY')
            } else {
                return '-'
            }
        },
        handleRemoveSelectedMember(memberNumber) {
            if (!this.formSubmitted) {
                const indexOfSelected = this.selected.findIndex(item => item === memberNumber)
                if (indexOfSelected >= 0) {
                    this.selected.splice(indexOfSelected, 1)
                }
            }
        },
        resetForm() {
            this.formSubmitted = false
            this.doneInsertMember = false
            this.$refs.form.reset()
        },
        async submitForm() {
            if (this.$refs && this.$refs.form && this.$refs.form.validate()) {
                this.displayLoading = true
                this.doneInsertMember = false
                if (!this.formSubmitted) {
                    this.formSubmitted = true

                    // Create an array of promises
                    const promises = this.selected.map(num =>
                        this.insertMemberToScopedBenefit({ MEMB_N: num.MEMB_N, ...this.data })
                    )

                    // Wait for all promises to resolve
                    await Promise.all(promises)

                    // Now set the flag
                    this.doneInsertMember = true
                    this.formSubmitted = false
                }
                this.displayLoading = false

            }
        }
    }
}
</script>

<style scoped>
.member-search {
    flex: 0 0 240px;
    max-width: 240px;
    margin: 0 8px;
    padding-top: 0;
}
.member-search .v-input__slot {
    min-height: 32px;
}

@media (max-width: 600px) {
    .member-search {
        flex-basis: 140px;
        max-width: 140px;
    }
}
</style>